package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/refund")
@Composable
fun RefundPage() {
    PageLayout(
        title = "Refund Policy",
        description = "Refund and cancellation policy for purchases on Arena Pro Play.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "Refund Policy") {
            InfoSection("1. What this policy covers") {
                InfoParagraph(
                    "This policy applies to purchases of Arena Coin packs made on arenaproplay.com. Coins are " +
                        "digital content used exclusively inside Arena Pro Play to unlock digital features such as " +
                        "AI-generated player card avatars and Pro events. Coins have no monetary value outside the " +
                        "service and cannot be cashed out, transferred between users, traded, or exchanged."
                )
            }
            InfoSection("2. Digital content and immediate delivery") {
                InfoParagraph(
                    "Coins are credited to your account immediately after a successful payment. By completing a " +
                        "purchase you request immediate delivery of this digital content and acknowledge that, " +
                        "where the law provides a statutory withdrawal period for online purchases, you lose the " +
                        "right of withdrawal once the content has been delivered and you start using it."
                )
            }
            InfoSection("3. When you can get a refund") {
                InfoBullet("You request the refund within 14 days of the purchase.")
                InfoBullet("The coins from that purchase have not been spent, in whole or in part.")
                InfoBullet(
                    "Refunds are issued to the original payment method, normally within 14 days of approval. " +
                        "The refunded coins are removed from your balance."
                )
            }
            InfoSection("4. When a refund is not available") {
                InfoBullet("Any part of the purchased coins has already been spent on features in the app.")
                InfoBullet("More than 14 days have passed since the purchase, unless applicable law says otherwise.")
                InfoBullet(
                    "The account associated with the purchase was terminated for a violation of our Terms of Service."
                )
            }
            InfoSection("5. Incorrect or duplicate charges") {
                InfoParagraph(
                    "If you were charged but did not receive your coins, were charged twice for one purchase, or " +
                        "believe a charge is otherwise incorrect, contact us and we will investigate and refund or " +
                        "credit the coins as appropriate. Please include the order reference from your payment " +
                        "receipt and the email associated with your Arena account."
                )
            }
            InfoSection("6. Purchases in the mobile app") {
                InfoParagraph(
                    "Coin purchases made in our iOS or Android apps are processed by the Apple App Store or Google " +
                        "Play. Refunds for those purchases are handled by the respective store under its own refund " +
                        "policy, and we cannot issue them directly."
                )
            }
            InfoSection("7. How to request a refund") {
                InfoParagraph(
                    "Contact us through the Supports link in the footer with your order reference and account " +
                        "email. We reply to refund requests within a few business days. Nothing in this policy " +
                        "limits any rights you have under mandatory consumer protection law in your country."
                )
            }
        }
    }
}
